export const CONTACT_LIST_REQUEST = 'CONTACT_LIST_REQUEST'
export const CONTACT_LIST_SUCCESS = 'CONTACT_LIST_SUCCESS'
export const CONTACT_LIST_FAIL = 'CONTACT_LIST_FAIL'


export const CONTACT_CREATE_REQUEST = 'CONTACT_CREATE_REQUEST'
export const CONTACT_CREATE_SUCCESS = 'CONTACT_CREATE_SUCCESS'
export const CONTACT_CREATE_FAIL = 'CONTACT_CREATE_FAIL'
export const CONTACT_CREATE_RESET='CONTACT_CREATE_RESET'

